export default __webpack_public_path__ + "static/media/category-icon-SellerWins.a640925a.svg";